<div
  class="table-cell"
  [ngClass]="{
    'confident': confidence > 0.5,
    'not-confident': confidence <= 0.5,
    'selected': isSelected,
    'disabled': isEditingDisabled
  }"
  (click)="clickedOnCell($event)"
  (contextmenu)="rightClicked($event)"
>
  <div class="fas fa-ellipsis-vertical amount-kebab-menu"
     (click)="rightClicked($event)"
     (contextmenu)="rightClicked($event)"
     title="More actions"></div>
  <app-double-click-to-edit
    [sourceComments]="cellForSourceComments.sourceComments"
    [value]="value"
    (changed)="cellValueChanged.emit($event)"
    (enteredEditMode)="enteredEditMode.emit(true)"
    [editing]="isEditing"
    [isEditingDisabled]="isEditingDisabled"
    [alignRight]="isNumeric"
    [formatAsCurrency]="isNumeric"
    [hasPadding]="true"
    [textFormat]="textFormat"
    [isStatementColumn]="true"
    (valueBeforeEditing) = "valueBeforeEditsMade.emit(value)"
  ></app-double-click-to-edit>
</div>
